/* eslint-disable import/prefer-default-export */
import PropTypes from 'prop-types'

// TODO: This is not working

export const CategoryShape = (propValue, key, componentName, location, propFullName) => {
  const obj = propValue[key]
  const prop = {}
  prop[propFullName] = obj

  // Check if `obj` is an Object using `PropTypes.object`
  const isObjectError = PropTypes.checkPropTypes(
    PropTypes.obj,
    obj,
    location,
    componentName,
    location,
  )
  if (isObjectError) {
    return isObjectError
  }

  return null
}
